<sc-flex vertical fitHeight stretchContent>
  <div class="no-field-space">
    <form [formGroup]="form">
      <sc-flex>

        <sc-date-field-legacy formControlName="dateFrom" labelDictionaryKey="tmc-visit.reporting.visitor-export.filter.from">
        </sc-date-field-legacy>

        <sc-content-spacer></sc-content-spacer>

        <sc-date-field-legacy formControlName="dateUntil" labelDictionaryKey="tmc-visit.reporting.visitor-export.filter.to">
        </sc-date-field-legacy>

        <sc-content-spacer></sc-content-spacer>

        <sc-button (click)="updateList()" [disabled]="isUpdateListDisabled()" dictionaryKey="tmc-visit.reporting.visitor-export.action.show"></sc-button>

        <sc-content-spacer></sc-content-spacer>

        <sc-button primary (click)="createExcel()" [disabled]="isCreateDisabled()" dictionaryKey="tmc-visit.reporting.visitor-export.action.export"></sc-button>

      </sc-flex>
    </form>
  </div>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex-fitting-content vertical>
    <sc-content-area fitHeight>
      <sc-scroll-pane>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.id"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.id}} </td>
          </ng-container>

          <!-- Reservation Column -->
          <ng-container matColumnDef="reservation">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.reservation"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.reservation}} </td>
          </ng-container>

          <!-- VisitStatus Column -->
          <ng-container matColumnDef="visitStatus">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.visit-status"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor">
              <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.visit-status.{{visitor.visitStatus}}"></sc-dictionary-label>
            </td>
          </ng-container>

          <!-- Arrival Column -->
          <ng-container matColumnDef="arrival">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.arrival"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.arrival}} </td>
          </ng-container>

          <!-- NumberPlate Column -->
          <ng-container matColumnDef="numberPlate">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.number-plate"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.numberPlate}} </td>
          </ng-container>

          <!-- Reason Column -->
          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.reason"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.reason}} </td>
          </ng-container>

          <!-- Notes Column -->
          <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.notes"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.notes}} </td>
          </ng-container>

          <!-- Company Column -->
          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.company"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.company}} </td>
          </ng-container>

          <!-- FirstName Column -->
          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.first-name"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.firstname}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.name"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.name}} </td>
          </ng-container>

          <!-- InRegularIntervals Column -->
          <ng-container matColumnDef="inRegularIntervals">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.in-regular-intervals"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.inRegularIntervals}} </td>
          </ng-container>

          <!-- RegistrationCode Column -->
          <ng-container matColumnDef="registrationCode">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.registration-code"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.registrationCode}} </td>
          </ng-container>

          <!-- RegistrationCode Column -->
          <ng-container matColumnDef="groupMembers">
            <th mat-header-cell *matHeaderCellDef>
              <sc-dictionary-label dictionaryKey="tmc-visit.reporting.visitor-export.group-members"></sc-dictionary-label>
            </th>
            <td mat-cell *matCellDef="let visitor"> {{visitor.groupMembers}} </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let visitor; columns: columnsToDisplay"></tr>
        </table>
      </sc-scroll-pane>
    </sc-content-area>

  </sc-flex-fitting-content>

</sc-flex>
